import { VariantProps } from 'class-variance-authority';
import { viewItemFieldVariants } from './logics';
import styles from './styles.module.scss';

type Props = {
  label: string;
  value: string;
  direction?: VariantProps<typeof viewItemFieldVariants>['direction'];
};

/**
 * 詳細画面で使用する項目名と値を表示するコンポーネント
 *
 * @param label - ラベル
 * @param value - 値
 * @param direction - レイアウト方向（column または row、デフォルトは column）
 * @returns
 */
export const ViewItemField: React.FC<Props> = ({ label, value, direction }) => (
  <div className={viewItemFieldVariants({ direction })}>
    <span className={styles.label}>{label}</span>
    <span className={styles.value}>{value}</span>
  </div>
);

type ViewItemFieldWithChildrenProps = Omit<Props, 'value'> & {
  children: React.ReactNode;
};

/**
 * 詳細画面で使用する項目名と任意の子要素を表示するコンポーネント
 *
 * value が文字列以外（バッジなど）の場合に使用する ViewItemField の派生コンポーネント。
 *
 * @param label - ラベル
 * @param direction - レイアウト方向（column または row、デフォルトは column）
 * @param children - 値の代わりに表示する子要素
 */
export const ViewItemFieldWithChildren: React.FC<ViewItemFieldWithChildrenProps> = ({
  label,
  direction,
  children,
}) => (
  <div className={viewItemFieldVariants({ direction })}>
    <span className={styles.label}>{label}</span>
    <div className={styles.value}>{children}</div>
  </div>
);
